const searchInput = document.querySelector('.header-search__input-field');

if (searchInput) {
  const searchForm = document.querySelector('[data-search-form]');

  const toggleSearchClass = (toggle) => {
    document.body.classList.toggle('is-open-search', toggle);

    if (toggle) {
      searchInput.focus();
    } else {
      searchInput.blur();
      searchForm.reset();
    }
  };

  attachEvent('.site-header__search-btn', 'click', (ev) => {
    const isOpen = document.body.classList.contains('is-open-search');
    toggleSearchClass(!isOpen);
    toggleBodyScrollLock(!isOpen);
    ev.preventDefault();
  });

  attachEvent('.header-search__close', 'click', (ev) => {
    toggleSearchClass(false);
    toggleBodyScrollLock(false);
    ev.preventDefault();
  });

  // Axios get search result
  const axiosGetSearchResult = async (search = '') => {
    const formDataInput = {
      action: 'getSearchResult',
      search,
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      document.querySelector('.header-search__body').innerHTML = response.data.data.html;
    } catch (err) {
      console.error(err);
    }
  };

  // event listener for ESC key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      toggleSearchClass(false);
      toggleBodyScrollLock(false);
      searchInput.value = '';
      axiosGetSearchResult();
    }
  });

  // event listener for Enter key - prevent form submission
  searchInput.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  });

  // event listener for search input
  searchInput.addEventListener(
    'keyup',
    debounce(() => {
      if (searchInput.value.length >= 3) {
        axiosGetSearchResult(searchInput.value);
      } else if (searchInput.value.length === 0) {
        axiosGetSearchResult();
      }
    }, 450),
  );

  // click event for suggested search
  attachEvent('.header-search__links a', 'click', (event) => {
    event.preventDefault();
    let { target } = event;
    if (!target.classList.contains('header-search__link')) {
      target = target.closest('.header-search__link');
    }

    if (target.getAttribute('href') === '#') {
      searchInput.value = target.dataset.text;
      axiosGetSearchResult(searchInput.value);
    }
  });

  // click event for header search reset
  attachEvent('.header-search__reset, .header-search__close', 'click', (event) => {
    event.preventDefault();
    searchInput.value = '';
    axiosGetSearchResult();
  });

  // update browsing history cookie
  const updateBrowsingHistoryCookie = (cookieName, cookieValue) => {
    if (!cookieValue) {
      return;
    }
    const existingValues = JSON.parse(Cookies.get(cookieName) || '[]');
    const index = existingValues.indexOf(cookieValue);
    if (index !== -1) {
      existingValues.splice(index, 1);
    }

    existingValues.unshift(cookieValue);

    if (existingValues.length > 4) {
      existingValues.pop();
    }

    Cookies.set(cookieName, JSON.stringify(existingValues));
  };

  // event to update browsing history
  const productListSection = document.querySelector('.sc-product-list');
  if (productListSection) {
    updateBrowsingHistoryCookie('browsing_history', productListSection.dataset.pageId || '');
  }

  // event to update browsing history for products
  const productModuleSection = document.querySelector('.sc-product-module');
  if (productModuleSection) {
    updateBrowsingHistoryCookie('browsing_history_product', productModuleSection.dataset.pageId || '');
  }
}
